<div class="profile-container">
    <div class="settings-header">
        <h2>PROFILE SETTINGS</h2>
        <p class="hint">Customise both your personal and practice information. These details are used for communication
            puproses between yourself, your practice, and your patients. The phone number and email under "Practice
            Information"
            will be used for patient communication. Also set security, patient file, practice network, associated
            hospital and letterhead settings. Appropriate settings will ensure MedicAI functions in a
            comprehensive manner. By proceeding, you agree to the <a
                href="assets/documents/IQject Terms of service - v0.5.pdf" target="_blank">terms of service</a>
            and <a href="assets/documents/IQject privacy notice - 21 January 2025.pdf" target="_blank">privacy
                policy</a>.</p>
    </div>
    <mat-accordion multi="false">

        <mat-expansion-panel [expanded]="true" *ngIf="userProfile" tutorialExpansionTarget="USER_PROFILE">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    {{userProfile.userType === 'doctor' ? 'PHYSICIAN' : 'ADMIN STAFF'}} PROFILE
                    <mat-icon class="expansion-header-icon" (click)="openEditProfileDialog($event)"
                        matTooltip="Edit your profile details" color="primary"
                        tutorialHighlightTarget="USER_PROFILE">edit</mat-icon>
                </mat-panel-title>
            </mat-expansion-panel-header>

            <ng-container *ngIf="userProfile; else loading">
                <!-- The photo lives on the messaging hub, so one picture serves every app (chat/components/profile-photo). -->
                <app-profile-photo></app-profile-photo>
                <p><strong>Title:</strong> {{ userProfile.title }}</p>
                <p><strong>Name:</strong> {{ userProfile.name }}</p>
                <p><strong>Surname:</strong> {{ userProfile.surname }}</p>
                <p><strong>Country:</strong> {{ userProfile.country }}</p>

                <ng-container *ngIf="userProfile.userType === 'doctor'">
                    <p><strong>Speciality:</strong> {{ userProfile.speciality }}</p>
                    <p><strong>HPCSA Number:</strong> {{ userProfile.mpNumber }}</p>
                </ng-container>


                <p><strong>Email:</strong> {{ userProfile.email }}</p>
                <p *ngIf="userProfile.phone"><strong>Phone Number:</strong> {{ userProfile.phone }}</p>

                <ng-container *ngIf="userProfile.userType === 'doctor'">
                    <ng-container *ngIf="userProfile.signatureImageUrl">
                        <strong>Physician Signature:</strong><br />
                        <img [src]="userProfile.signatureImageUrl" alt="Physician Signature" />
                    </ng-container>
                </ng-container>
            </ng-container>
        </mat-expansion-panel>




        <mat-expansion-panel *ngIf="isAdmin()" class="m-t-10" tutorialExpansionTarget="PRACTICE_PROFILE">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    PRACTICE PROFILE
                    <mat-icon class="expansion-header-icon" (click)="openEditGroupProfileDialog($event)"
                        matTooltip="Edit your practice profile details" color="primary"
                        tutorialHighlightTarget="PRACTICE_PROFILE">edit</mat-icon>
                </mat-panel-title>
            </mat-expansion-panel-header>

            <ng-container *ngIf="groupProfile; else loading">
                <p><strong>Practice Name:</strong> {{ groupProfile.name }}</p>
                <p><strong>About the Practice:</strong> {{ groupProfile.about }}</p>
                <p><strong>Practice Number:</strong> {{ groupProfile.practiceNumber }}</p>
                <!-- <p><strong>Practice Number (Full):</strong> {{ groupProfile.fullPracticeNumber }}</p> -->
                <p><strong>Practice Phone Number:</strong> {{ groupProfile.practicePhone }}</p>
                <p><strong>Practice Email:</strong> {{ groupProfile.practiceEmail }}</p>
                <p><strong>Practice Open Times:</strong> {{ groupProfile.practiceOpeningTimes }}</p>
                <p><strong>Auto Generate Sick Notes:</strong> {{ groupProfile.autoGenerateSickNotes ? 'Yes' :
                    'No' }}</p>
                <p><strong>Auto Complete Invites:</strong> {{ groupProfile.autoCompleteInvites ? 'Yes' :
                    'No' }}</p>
                <!--  <p><strong>Send Patient Satisfaction Surveys:</strong> {{ groupProfile.sendSatisfactionSurveys ? 'Yes' :
                    'No' }}</p> -->
            </ng-container>
        </mat-expansion-panel>




        <!-- <mat-expansion-panel *ngIf="isAdmin()">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    PATIENT FILE SETTINGS
                </mat-panel-title>
            </mat-expansion-panel-header>

            <ng-container *ngIf="groupProfile; else loading">
                <p class="hint">
                    Automatically generates a patient file number for each new patient. Doctors can manually delete or
                    change this number if needed. Existing numbers will not be overridden. It is recommended to maintain
                    consistency by not editing these numbers once generated.
                </p>
                <div class="toggle-container">
                    <mat-slide-toggle [(ngModel)]="groupProfile.generatePatientNumbers" color="primary"
                        labelPosition="before" (change)="toggleGeneratePatientNumbers($event)">Automated
                        Patient File Number Generation</mat-slide-toggle>
                </div>

            </ng-container>
        </mat-expansion-panel> -->


        <mat-expansion-panel *ngIf="isAdmin()" tutorialExpansionTarget="PRACTICE_NETWORK">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    PRACTICE NETWORK
                    <mat-icon class="expansion-header-icon" (click)="openAddUserDialog($event)"
                        matTooltip="Invite a new user to join this group" color="primary"
                        tutorialHighlightTarget="PRACTICE_NETWORK">person_add</mat-icon>
                </mat-panel-title>
            </mat-expansion-panel-header>

            <ng-container *ngIf="groupUsers; else loading">
                <mat-form-field class="full-width" appearance="outline">
                    <mat-label>Group Users</mat-label>
                    <mat-chip-grid #chipGrid>
                        <mat-chip-row *ngFor="let user of groupUsers" appTouchEdit (dblclick)="editUser(user)"
                            [matTooltip]="getTooltipText(user)">
                            {{user.title}} {{user.name}} {{user.surname}}
                            <span *ngIf="user.isOwner"> (Group Owner)</span>
                            <span *ngIf="user.isPending"> (Pending)</span>
                            <button matChipRemove (click)="removeUser(user)" *ngIf="!user.isOwner">
                                <mat-icon>cancel</mat-icon>
                            </button>
                        </mat-chip-row>
                    </mat-chip-grid>
                    <input [matChipInputFor]="chipGrid" disabled />
                    <mat-hint>Double click or tap and hold a group user (not pending) to edit their user rights</mat-hint>
                </mat-form-field>
            </ng-container>
        </mat-expansion-panel>


        <mat-expansion-panel *ngIf="isAdmin()" tutorialExpansionTarget="ASSOCIATED_HOSPITALS">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    ASSOCIATED HOSPITALS
                    <mat-icon class="expansion-header-icon" (click)="openAddHospitalDialog($event)"
                        matTooltip="Add a new hospital with the relevant wards" color="primary"
                        tutorialHighlightTarget="ASSOCIATED_HOSPITALS">add</mat-icon>
                </mat-panel-title>
            </mat-expansion-panel-header>

            <ng-container>
                <mat-form-field class="full-width" appearance="outline">
                    <mat-label>Hospitals</mat-label>
                    <mat-chip-grid #chipGrid>
                        <mat-chip-row *ngFor="let hospital of hospitals" appTouchEdit (dblclick)="editHospital(hospital)"
                            [matTooltip]="getHospitalTooltipText(hospital)">
                            {{hospital.name}}
                            <button matChipRemove (click)="removeHospital(hospital)">
                                <mat-icon>cancel</mat-icon>
                            </button>
                        </mat-chip-row>
                    </mat-chip-grid>
                    <input [matChipInputFor]="chipGrid" disabled />
                    <mat-hint>Double click or tap and hold a hospital to edit its information</mat-hint>
                </mat-form-field>
            </ng-container>
        </mat-expansion-panel>


        <mat-expansion-panel *ngIf="isAdmin()">
            <mat-expansion-panel-header tutorialExpansionTarget="LETTERHEAD">
                <mat-panel-title>
                    LETTERHEAD
                </mat-panel-title>
            </mat-expansion-panel-header>

            <ng-container>

                <app-file-upload [fileObjects]="headerImageObjects" [allowMultiple]="false"
                    [allowedFileTypes]="'image/*'" title="Header Image" (fileUpload)="onHeaderImageUpload($event)"
                    (fileDelete)="onImageDelete($event, 'header')"
                    hintMessage="We suggest an image size of 1200px x 200px for optimal results" [pasteEnabled]="false">
                </app-file-upload>

                <app-file-upload [fileObjects]="footerImageObjects" [allowMultiple]="false"
                    [allowedFileTypes]="'image/*'" title="Footer Image" (fileUpload)="onFooterImageUpload($event)"
                    (fileDelete)="onImageDelete($event, 'footer')"
                    hintMessage="We suggest an image size of 1200px x 200px for optimal results" [pasteEnabled]="false">
                </app-file-upload>

                <div class="m-t-10" *ngIf="headerImageObjects">
                    <button mat-raised-button color="primary" (click)="previewLetterhead()">Preview PDF
                        Download</button>
                </div>

            </ng-container>
        </mat-expansion-panel>


        <mat-expansion-panel *ngIf="isGroupUser()" class="m-t-10">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    GROUP SETTINGS
                </mat-panel-title>
            </mat-expansion-panel-header>

            <ng-container>
                <p>Important: If you leave this group, you will lose all access to the data associated with this group.
                    To regain access, you would need to request to be added again by a group administrator.</p>
                <button mat-raised-button color="warn" (click)="leaveGroup()"><mat-icon>logout</mat-icon>Leave
                    Group</button>
            </ng-container>
        </mat-expansion-panel>

        <mat-expansion-panel *ngIf="isDoctor()" class="m-t-10" tutorialExpansionTarget="MEDICATION_BUNDLES"
            [appGroupSpecialtyHide]="{ specialties: ['Physiotherapy'], condition: 'exclude' }">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    MEDICATION BUNDLES
                    <mat-icon class="expansion-header-icon" (click)="openAddMedicationBundleDialog($event)"
                        matTooltip="Add a new medication bundle" color="primary"
                        tutorialHighlightTarget="MEDICATION_BUNDLES">add</mat-icon>
                </mat-panel-title>
            </mat-expansion-panel-header>

            <ng-container>
                <mat-form-field class="full-width" appearance="outline">
                    <mat-label>Bundles</mat-label>
                    <mat-chip-grid #chipGrid>
                        <mat-chip-row *ngFor="let bundle of medicationBundles"
                            appTouchEdit (dblclick)="editMedicationBundle(bundle)">
                            {{bundle.label}}
                            <button matChipRemove (click)="removeMedicationBundle(bundle)">
                                <mat-icon>cancel</mat-icon>
                            </button>
                        </mat-chip-row>
                    </mat-chip-grid>
                    <input [matChipInputFor]="chipGrid" disabled />
                    <mat-hint>Double click or tap and hold a medication bundle to edit its information</mat-hint>
                </mat-form-field>
            </ng-container>
        </mat-expansion-panel>

        <mat-expansion-panel *ngIf="isDoctor()" tutorialExpansionTarget="PREFERRED_MEDICATION"
            [appGroupSpecialtyHide]="{ specialties: ['Physiotherapy'], condition: 'exclude' }">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    PREFERRED MEDICATION
                    <mat-icon class="expansion-header-icon" (click)="openPreferredMedicationDialog($event)"
                        matTooltip="Configure a list of the medication you prefer when prescribing" color="primary"
                        tutorialHighlightTarget="PREFERRED_MEDICATION">edit</mat-icon>
                </mat-panel-title>
            </mat-expansion-panel-header>

            <ng-container>
                <mat-form-field class="full-width" appearance="outline">
                    <mat-label>Medication</mat-label>
                    <mat-chip-grid #preferredMedsChipGrid>
                        <mat-chip-row *ngFor="let med of userProfile.preferredMedication">
                            {{med.name || med.medication}}
                            <button matChipRemove (click)="removePreferredMedication(med)">
                                <mat-icon>cancel</mat-icon>
                            </button>
                        </mat-chip-row>
                    </mat-chip-grid>
                    <input [matChipInputFor]="preferredMedsChipGrid" disabled />
                </mat-form-field>
            </ng-container>
        </mat-expansion-panel>

        <mat-expansion-panel *ngIf="isDoctor() && !stateMode" tutorialExpansionTarget="PREFERRED_LAB_TESTS"
            [appGroupSpecialtyHide]="{ specialties: ['Physiotherapy'], condition: 'exclude' }">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    PREFERRED LAB TESTS
                    <mat-icon class="expansion-header-icon" (click)="openAddLabTestBundleDialog($event)"
                        matTooltip="Add a lab test bundle" color="primary"
                        tutorialHighlightTarget="PREFERRED_LAB_TESTS">add</mat-icon>
                </mat-panel-title>
            </mat-expansion-panel-header>

            <ng-container>
                <div *ngFor="let bundle of labTestBundles" class="note-type-section">
                    <div class="action-heading">
                        <h3 class="m-r-10">{{ bundle.label }}</h3>
                        <!-- <div class="toggle-container">
                            <span class="lab-info">Lab: {{ bundle.lab || 'Lancet' }}</span>
                        </div> -->
                        <button mat-icon-button (click)="openAddLabTestBundleDialog($event, bundle)"
                            matTooltip="Edit this lab test bundle"><mat-icon>edit</mat-icon></button>
                        <button mat-icon-button (click)="deleteLabTestBundle(bundle.id)"
                            matTooltip="Delete this lab test bundle" color="warn"><mat-icon>delete</mat-icon></button>
                    </div>
                    <app-lab-test-selector [mode]="'chips'" [testChips]="bundle.labTests" [showCategoryFilter]="true"
                        [pluralTitle]="'Lab Tests'" [singularTitle]="'Lab Test'"
                        (testsChanged)="onLabTestBundleTestsChanged($event, bundle)">
                    </app-lab-test-selector>
                </div>

            </ng-container>
        </mat-expansion-panel>

        <mat-expansion-panel class="m-t-10">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    SECURITY
                    <mat-icon class="expansion-header-icon" (click)="openEditSecuritySettingsDialog($event)"
                        matTooltip="Edit your security settings" color="primary">edit</mat-icon>
                </mat-panel-title>
            </mat-expansion-panel-header>

            <ng-container *ngIf="userProfile; else loading">
                <p><strong>Auto Logout Time:</strong> {{ userProfile.autoLogoutTime }} minutes</p>

                <button mat-raised-button color="warn" class="m-t-10"
                    (click)="openChangePasswordDialog()"><mat-icon>password</mat-icon>Change
                    Password</button>
            </ng-container>
        </mat-expansion-panel>



        <mat-expansion-panel *ngIf="isAdmin()" tutorialExpansionTarget="SUPPORT_CONTACT">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    SUPPORT
                </mat-panel-title>
            </mat-expansion-panel-header>

            <ng-container>
                <p>Important: Requesting support will send MedicAI an email and create a support user in your group
                    which will allow us to assist you. This user will automatically be removed once the support ticket
                    has been closed.</p>
                <button mat-raised-button color="warn"
                    (click)="requestSupport()"><mat-icon>contact_support</mat-icon>Request
                    Support</button>
                <button mat-raised-button class="whatsapp-support-btn m-l-10"
                    (click)="openWhatsAppSupport()"
                    [disabled]="!userProfile || !groupProfile || openingWhatsAppSupport">
                    <mat-icon svgIcon="whatsapp"></mat-icon> WhatsApp Support
                </button>
                <!-- 
                <p class="m-t-10">Important: Resetting the tutorial status will show you the entire tutorial slide deck
                </p>
                <button mat-raised-button color="warn"
                    (click)="restartTutorial()"><mat-icon>contact_support</mat-icon>Reset Tutorial
                </button> 
            -->
            </ng-container>
        </mat-expansion-panel>

    </mat-accordion>
    <div class="mobile-spacer"></div>
</div>

<ng-template #loading>
    <div class="loader">
        <mat-spinner></mat-spinner>
        <p>Loading details...</p>
    </div>
</ng-template>

<ng-template #groupSettingsDialog>
    <h1 mat-dialog-title>Practice Profile Details</h1>

    <div mat-dialog-content>
        <div class="form-container">
            <div class="form-section">

                <mat-form-field appearance="outline" class="full-width m-t-10">
                    <mat-label>Name</mat-label>
                    <input matInput [(ngModel)]="groupProfile.name" placeholder="Name" type="text" required>
                </mat-form-field>

                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>About The Practice</mat-label>
                    <textarea matInput cdkTextareaAutosize="false" rows="10"
                        [(ngModel)]="groupProfile.about"></textarea>
                </mat-form-field>
                <div class="field-row">
                    <mat-form-field appearance="outline">
                        <mat-label>Practice Number (Short)</mat-label>
                        <input matInput [(ngModel)]="groupProfile.practiceNumber" placeholder="Practice Number"
                            type="text">
                    </mat-form-field>

                    <!-- <mat-form-field appearance="outline">
                        <mat-label>Practice Number (13 Digit)</mat-label>
                        <input matInput [(ngModel)]="groupProfile.fullPracticeNumber" placeholder="Practice Number"
                            type="text" maxlength="13" minlength="13" pattern="[0-9]*">
                    </mat-form-field> -->

                    <app-intl-phone-input [preferredCountries]="['za']" [providedValue]="groupProfile.practicePhone"
                        placeholder="Practice Phone Number" (valueChange)="groupProfile.practicePhone = $event"
                        name="practicePhone"></app-intl-phone-input>

                    <mat-form-field appearance="outline">
                        <mat-label>Practice Email</mat-label>
                        <input matInput [(ngModel)]="groupProfile.practiceEmail" placeholder="Practice Email"
                            type="email">
                    </mat-form-field>

                    <!-- What forms ask of the practice; CURA fills these in from here. -->
                    <mat-form-field appearance="outline">
                        <mat-label>Practice Fax</mat-label>
                        <input matInput [(ngModel)]="groupProfile.practiceFax" placeholder="Practice Fax" type="tel"
                            name="practiceFax">
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                        <mat-label>Town (where forms are signed)</mat-label>
                        <input matInput [(ngModel)]="groupProfile.practiceTown" placeholder="Johannesburg" type="text"
                            name="practiceTown">
                    </mat-form-field>
                </div>

                <!--
                    Practice email domains. Confirming one means letters to that domain are sent
                    UNENCRYPTED, so the consequence is stated in the hint rather than left to be
                    inferred from the label. Nothing is confirmed by default.
                -->
                <div class="internal-domains">
                    <h4>Practice Email Domains</h4>
                    <p class="internal-domains__hint">
                        Letters and clinical documents sent to these domains are treated as staying
                        inside the practice: they are sent as normal PDF attachments, with
                        <strong>no password protection</strong>. Everyone else, including patients,
                        continues to receive a password-protected file. Only add domains your
                        practice controls.
                    </p>

                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Practice Email Domains</mat-label>
                        <mat-chip-grid #domainGrid aria-label="Practice email domains">
                            <mat-chip-row *ngFor="let domain of confirmedInternalDomains"
                                (removed)="removeInternalDomain(domain)">
                                {{ domain }}
                                <button matChipRemove [matTooltip]="'Remove ' + domain">
                                    <mat-icon>cancel</mat-icon>
                                </button>
                            </mat-chip-row>
                            <input placeholder="e.g. yourpractice.co.za" [matChipInputFor]="domainGrid"
                                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                [matChipInputAddOnBlur]="true"
                                (matChipInputTokenEnd)="addInternalDomain($event)" />
                        </mat-chip-grid>
                        <mat-hint *ngIf="confirmedInternalDomains.length === 0">
                            None added — every recipient currently receives a password-protected file.
                        </mat-hint>
                    </mat-form-field>

                    <div *ngIf="unconfirmedSuggestions.length">
                        <p class="internal-domains__hint">
                            From your practice contact addresses — click to add:
                        </p>
                        <mat-chip-set aria-label="Suggested practice email domains">
                            <mat-chip *ngFor="let domain of unconfirmedSuggestions"
                                (click)="addInternalDomainValue(domain)">
                                <mat-icon matChipAvatar>add</mat-icon>
                                {{ domain }}
                            </mat-chip>
                        </mat-chip-set>
                    </div>
                </div>
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Practice Open Times</mat-label>
                    <input matInput [(ngModel)]="groupProfile.practiceOpeningTimes" placeholder="Practice Open Times"
                        type="text">
                </mat-form-field>
                <!-- tasks/patient-app.md §4.5: with patient-app hours set, THEY are what patients are shown, so the
                     practice can see the sentence its patients read - and is told when this text disagrees with it. -->
                <p class="hint" *ngIf="patientAppFeatureEnabled && !stateMode && patientHoursText" data-test="patient-facing-hours"
                    [class.warning]="hoursDisagree">
                    <ng-container *ngIf="hoursDisagree">This text does not match your patient-app hours. </ng-container>
                    Patients are shown your patient-app hours: <strong>{{ patientHoursText }}</strong>
                </p>

                <!-- tasks/patient-app.md §4.5: the machine-readable twin of the text above, read by the patient app's
                     out-of-hours reply. Leave it off and the app never says the practice is closed. -->
                <div class="toggle-container toggle-column practice-hours" data-test="practice-hours" *ngIf="patientAppFeatureEnabled && !stateMode">
                    <mat-slide-toggle [ngModel]="!!groupProfile.practiceHours" (ngModelChange)="setStructuredHours($event)" color="primary">
                        Set opening hours for the patient app
                    </mat-slide-toggle>
                    <p class="hint">Messages that patients send outside these hours get the after-hours reply below. Keep
                        them in step with the open times text above.</p>
                    <ng-container *ngIf="groupProfile.practiceHours as hours">
                        <div class="practice-hours__day" *ngFor="let day of practiceDays">
                            <span class="practice-hours__label">{{ day.label }}</span>
                            <span class="hint" *ngIf="!hours.week[day.key]?.length">Closed</span>
                            <span class="practice-hours__range" *ngFor="let range of hours.week[day.key]; let i = index">
                                <!-- The app's own time picker (as in Schedule Settings), not the browser's: it is themed for
                                     light and dark mode and writes the same 24-hour "HH:mm" the patient app reads. -->
                                <mat-form-field appearance="outline" class="practice-hours__time" subscriptSizing="dynamic">
                                    <mat-label>Opens</mat-label>
                                    <input matInput [(ngModel)]="range.from" [ngxTimepicker]="fromPicker" [format]="24"
                                        [attr.aria-label]="day.label + ' opens'">
                                    <ngx-material-timepicker #fromPicker [theme]="timepickerTheme" [appendToInput]="true"
                                        [preventOverlayClick]="true"></ngx-material-timepicker>
                                </mat-form-field>
                                <span class="practice-hours__dash">–</span>
                                <mat-form-field appearance="outline" class="practice-hours__time" subscriptSizing="dynamic">
                                    <mat-label>Closes</mat-label>
                                    <input matInput [(ngModel)]="range.to" [ngxTimepicker]="toPicker" [format]="24"
                                        [attr.aria-label]="day.label + ' closes'">
                                    <ngx-material-timepicker #toPicker [theme]="timepickerTheme" [appendToInput]="true"
                                        [preventOverlayClick]="true"></ngx-material-timepicker>
                                </mat-form-field>
                                <button mat-icon-button type="button" (click)="hours.week[day.key].splice(i, 1)" matTooltip="Remove">
                                    <mat-icon>close</mat-icon>
                                </button>
                            </span>
                            <button mat-button type="button" (click)="addHoursRange(day.key)">Add hours</button>
                        </div>
                        <mat-checkbox [(ngModel)]="hours.publicHolidaysClosed">Closed on public holidays</mat-checkbox>
                    </ng-container>
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>After-hours message</mat-label>
                        <textarea matInput rows="3" maxlength="1000" [(ngModel)]="groupProfile.afterHoursMessage"
                            placeholder="Thank you for your message. The practice is closed; we will reply when we open. In an emergency, call 10177."></textarea>
                        <mat-hint>Sent to a patient who messages the practice in the app outside the hours above.</mat-hint>
                    </mat-form-field>
                </div>

                <h3>Practice Settings</h3>

                <div class="toggle-container toggle-column" *ngIf="!stateMode">
                    <mat-slide-toggle [(ngModel)]="groupProfile.autoCompleteInvites" color="primary">Auto Complete
                        Invites</mat-slide-toggle>

                    <p class="hint">
                        Note: If this option is enabled, patient invites will be automatically completed with a
                        diagnosis of "UNSPECIFIED" and an ICD-10 code of "Z00.0". The file will be flagged for review by
                        the practice.
                    </p>
                </div>

                <div class="toggle-container toggle-column">
                    <mat-slide-toggle [(ngModel)]="groupProfile.disableConsentWarningsForProcedures"
                        color="primary">Disable Consent Warnings for Procedures</mat-slide-toggle>

                    <p class="hint">
                        Note: If this option is enabled, the system will not display warnings for missing procedure
                        consent forms on the calendar.
                    </p>
                </div>

                <div class="toggle-container toggle-column">
                    <mat-slide-toggle [(ngModel)]="groupProfile.calendarSplitByPhysician" color="primary">Calendar split
                        by treating physician</mat-slide-toggle>

                    <p class="hint">
                        When enabled, appointments can be assigned a treating physician, the calendar can be filtered by
                        doctor, and slot availability is evaluated per physician.
                    </p>
                </div>

                <div class="toggle-container toggle-column" *ngIf="!stateMode">
                    <mat-slide-toggle [(ngModel)]="groupProfile.enforcedInviteSections.nextOfKin"
                        color="primary">Enforce Next of Kin / Emergency Contact</mat-slide-toggle>

                    <p class="hint">
                        Note: If this option is enabled, patients will be required to provide at least one emergency
                        contact or next of kin when completing their invite form. The option to skip this section will
                        be hidden.
                    </p>
                </div>

                <h3>Auto Generate Settings</h3>

                <div class="toggle-container toggle-column">
                    <mat-slide-toggle [(ngModel)]="groupProfile.autoGenerateSections.dischargeSummary"
                        color="primary">Auto Generate Discharge Summary</mat-slide-toggle>

                    <p class="hint">
                        Note: If this option is enabled, the system will automatically generate a discharge summary when
                        you navigate to the discharge page.
                    </p>

                    <!-- <mat-slide-toggle [(ngModel)]="groupProfile.autoGenerateSections.patientDischargeSummary"
                        color="primary">Auto Generate Patient Summary On Discharge</mat-slide-toggle>

                    <p class="hint">
                        Note: If this option is enabled, the system will automatically generate a discharge summary for
                        the patientwhen you navigate to the discharge page.
                    </p> -->

                    <mat-slide-toggle [(ngModel)]="groupProfile.autoGenerateSickNotes" color="primary">
                        Auto Generate Sick Notes</mat-slide-toggle>

                    <p class="hint">
                        Note: If this option is enabled, the system will automatically generate a sick note for each
                        AI Request once it has been processed.
                    </p>


                </div>

                <!-- The MedicAI patient app (tasks/patient-app.md P7, P15, §15). Outside the ICD-10 preview box below:
                     that box's 1 January 2027 cut-off is about coding, not about the patient app. -->
                <div class="patient-app-settings" *ngIf="patientAppFeatureEnabled && !stateMode">
                    <h3>MedicAI patient app</h3>
                    <!-- Patient app linking (tasks/patient-app.md P7, P15). Admins only; the server checks too. -->
                    <div class="toggle-container toggle-column" data-test="patient-app-linking">
                        <mat-slide-toggle [(ngModel)]="groupProfile.patientAppEnabled" color="primary" [disabled]="!isAdmin()">
                            Enable patient app linking
                        </mat-slide-toggle>

                        <p class="hint">
                            Offers patients "Use the MedicAI app" on the first screen of your invite: they complete the
                            invite in the app, and their file here is linked to it with their consent. Linked files show a
                            "Linked to patient app" mark. While this is off, patients are not offered the app at all.
                            Switching it off ends every patient's link; they keep what they already received.
                            <ng-container *ngIf="!isAdmin()"> Only a practice administrator can change this.</ng-container>
                        </p>
                    </div>

                    <div class="toggle-container toggle-column" data-test="patient-app-billing" [class.patient-app-toggle--dimmed]="!groupProfile.patientAppEnabled">
                        <mat-slide-toggle [ngModel]="groupProfile.patientAppSendBilling !== false"
                            (ngModelChange)="groupProfile.patientAppSendBilling = $event" color="primary" [disabled]="!isAdmin() || !groupProfile.patientAppEnabled">
                            Send invoices and receipts to the patient app
                        </mat-slide-toggle>
                        <p class="hint">
                            Linked patients see this practice's invoices, receipts and statements in the app, with the PDF.
                            Estimates and drafts are never sent. Switching it off stops new ones; what was sent stays.
                        </p>
                    </div>

                    <div class="toggle-container toggle-column" data-test="patient-app-emails" [class.patient-app-toggle--dimmed]="!groupProfile.patientAppEnabled">
                        <mat-slide-toggle [ngModel]="groupProfile.patientAppSendEmails !== false"
                            (ngModelChange)="groupProfile.patientAppSendEmails = $event" color="primary" [disabled]="!isAdmin() || !groupProfile.patientAppEnabled">
                            Copy emails to the patient app
                        </mat-slide-toggle>
                        <p class="hint">
                            Linked patients also see a copy of every email this practice sends them in the app's inbox.
                            A consent, form or invite link is never mirrored: it arrives as its own item instead.
                            Switching it off stops new ones; what was sent stays.
                        </p>
                    </div>

                    <div class="toggle-container toggle-column" data-test="patient-app-requests" [class.patient-app-toggle--dimmed]="!groupProfile.patientAppEnabled">
                        <mat-slide-toggle [ngModel]="groupProfile.patientAppSendRequests === true"
                            (ngModelChange)="groupProfile.patientAppSendRequests = $event" color="primary" [disabled]="!isAdmin() || !groupProfile.patientAppEnabled">
                            Send consents and forms to the patient app
                        </mat-slide-toggle>
                        <p class="hint">
                            Linked patients complete a practice's consent or form request in the app instead of by email.
                            Switching it off stops new ones; a request already sent stays until it is signed or expires.
                        </p>
                    </div>
                </div>

                <!-- ICD-10 Coding Assistant — PREVIEW.
                     The section is wrapped so the preview status and the 1 January 2027
                     cut-off are attached to the feature itself rather than sitting as a
                     loose paragraph that can drift away from the toggle it qualifies.
                     The auto-suggestion toggles inside remain commented out deliberately. -->
                <div class="feature-preview" *ngIf="!stateMode">
                    <div class="feature-preview__header">
                        <h3>ICD-10 Coding Assistant</h3>
                        <span class="feature-preview__chip">Preview</span>
                    </div>

                    <p class="feature-preview__notice">
                        This feature is currently in <strong>preview</strong>. From
                        <strong>1 January 2027</strong> it will be automatically disabled for practices that
                        are not linked to the <strong>MedicAI Connect Billing Platform</strong>
                        <em>(coming soon)</em>.
                    </p>


                    <div class="toggle-container toggle-column">
                        <mat-slide-toggle [(ngModel)]="groupProfile.icdSuggestionsEnabled" color="primary"
                            (change)="onIcdSuggestionsEnabledChange($event.checked)">
                            Enable ICD-10 Coding Suggestions
                        </mat-slide-toggle>

                        <p class="hint">
                            Reviews each patient's clinical notes overnight and suggests improvements to their ICD-10
                            coding, using the South African Master Industry Table. Nothing runs for this practice while
                            this is off - no notes are processed and no cost is incurred.
                        </p>
                    </div>

                    <ng-container *ngIf="groupProfile.icdSuggestionsEnabled">
                        <!-- <div class="toggle-container toggle-column">
                            <mat-slide-toggle [(ngModel)]="groupProfile.autoAcceptIcdSuggestions" color="primary"
                                [disabled]="!icdAutoAcceptStatus?.permitted">
                                Automatically Apply Suggested Additions
                            </mat-slide-toggle>

                            <p class="hint" *ngIf="icdAutoAcceptStatus && !icdAutoAcceptStatus.permitted">
                                <strong>Not available yet.</strong> {{ icdAutoAcceptStatus.reason }}.
                                Suggestions still appear for review in the meantime - accepting and rejecting them
                                is what builds up the measurement.
                            </p>
                            <p class="hint" *ngIf="icdAutoAcceptStatus && icdAutoAcceptStatus.permitted">
                                Available: {{ icdAutoAcceptStatus.reason }}.
                            </p>
                            <p class="hint" *ngIf="icdAutoAcceptStatusLoading">Checking this practice's accuracy&hellip;</p>

                            <p class="hint">
                                Only <strong>additions</strong> are ever applied automatically, and only when a second
                                independent check agrees. Suggested <strong>removals</strong> are never applied
                                automatically - they are flagged on the code for a clinician to decide.
                            </p>
                        </div> -->

                        <!-- <mat-form-field appearance="outline" class="full-width m-t-10">
                            <mat-label>Minimum Confidence for Automatic Application</mat-label>
                            <input matInput [(ngModel)]="groupProfile.icdAutoAcceptMinConfidence" type="number"
                                min="0.75" max="1" step="0.01" placeholder="0.9">
                            <mat-hint>Between 0.75 and 1. Values below 0.75 are ignored and the 0.9 default is used
                                instead.</mat-hint>
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="full-width m-t-20">
                            <mat-label>Episode Gap Override (days)</mat-label>
                            <input matInput [(ngModel)]="groupProfile.icdEpisodeGapDays" type="number" min="1" max="730"
                                placeholder="Leave blank to use the discipline default">
                            <mat-hint>How long a gap between notes starts a new episode of care. Leave blank unless the
                                discipline default is wrong for this practice.</mat-hint>
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="full-width m-t-20">
                            <mat-label>Suggestion Retention (days)</mat-label>
                            <input matInput [(ngModel)]="groupProfile.icdSuggestionRetentionDays" type="number" min="7"
                                max="365" placeholder="90">
                            <mat-hint>Unreviewed suggestions expire after this long, so stale flags do not
                                accumulate.</mat-hint>
                        </mat-form-field> -->
                    </ng-container>
                </div>

            </div>
        </div>
    </div>

    <mat-dialog-actions align="end">
        <div mat-dialog-actions class="dialog-actions">
            <button mat-raised-button color="primary" [mat-dialog-close]="groupProfile">Save</button>
        </div>
    </mat-dialog-actions>

</ng-template>


<ng-template #securitySettingsDialog>
    <h1 mat-dialog-title>Security Settings</h1>


    <div mat-dialog-content>
        <div class="form-container">
            <div class="form-section">
                <mat-form-field appearance="outline" class="full-width m-t-10">
                    <mat-label>Auto Logout Time</mat-label>
                    <input matInput [(ngModel)]="userProfile.autoLogoutTime" type="number" min="5" max="180" required>
                    <span matSuffix> minutes </span>
                    <mat-hint class="hint">Min: 5 minutes. Max: 180 minutes</mat-hint>
                </mat-form-field>

            </div>
        </div>
    </div>

    <mat-dialog-actions align="end">
        <div mat-dialog-actions class="dialog-actions">
            <button mat-raised-button color="primary" [mat-dialog-close]="userProfile">Save</button>
        </div>
    </mat-dialog-actions>

</ng-template>

<ng-template #inviteUserDialog>
    <h1 mat-dialog-title>User Details</h1>
    <div mat-dialog-content>
        <div class="p-t-20">
            <mat-form-field appearance="outline" class="m-r-10">
                <mat-label>Name</mat-label>
                <input matInput [(ngModel)]="invitingUser.name" placeholder="Name" type="text" required
                    [disabled]="invitingUser.isEdit">
            </mat-form-field>
            <mat-form-field appearance="outline" class="m-r-10">
                <mat-label>Email</mat-label>
                <input matInput [(ngModel)]="invitingUser.email" placeholder="Email" type="email" required
                    [disabled]="invitingUser.isEdit">
            </mat-form-field>
            <mat-form-field appearance="outline">
                <mat-label>User Rights</mat-label>
                <mat-select [(ngModel)]="invitingUser.userRole" required>
                    <!-- A doctor's account is a Physician or an Admin; Physician is only for a doctor (utils/memberRoles.js). -->
                    <mat-option value="Support-Limited" *ngIf="invitingUser.userType !== 'doctor'">Support Staff (Limited)</mat-option>
                    <mat-option value="Support-Unlimited" *ngIf="invitingUser.userType !== 'doctor'">Support Staff (Unlimited)</mat-option>
                    <mat-option value="Physician" *ngIf="!invitingUser.isEdit || invitingUser.userType === 'doctor'">Physician</mat-option>
                    <mat-option value="Admin" *ngIf="invitingUser.isEdit">Admin</mat-option>
                    <!-- <mat-option value="Admin">Support Request</mat-option> -->
                </mat-select>
            </mat-form-field>
        </div>

        <p class="hint">User Rights Information:</p>
        <div class="hint">
            'Support Staff (Limited)' can access EMR features only.<br />
            'Support Staff (Unlimited)' has access to EMR features as well as AI recording features.<br />

            'Physician' has access to EMR features as well as AI recording features.<br />
            'Admin' has access to all features including practice settings.<br />
            <ng-container
                *ngIf="invitingUser.userRole && invitingUser.userRole !== 'Physician' && invitingUser.userType !== 'doctor'">
                <br />
                <mat-slide-toggle [checked]="false" [disabled]="invitingUser.userRole === 'Physician'" color="primary"
                    [(ngModel)]="invitingUser.canSignOnDoctorsBehalf">
                    Can Sign On Doctor's Behalf
                </mat-slide-toggle>
                <br />
            </ng-container>

            <ng-container
                *ngIf="invitingUser.userRole && invitingUser.userRole !== 'Physician' && invitingUser.userType !== 'doctor'">
                <br />
                <mat-slide-toggle [checked]="false" color="primary" [(ngModel)]="invitingUser.canSeeFinancials">
                    Can View Statistics
                </mat-slide-toggle>
                <br />
            </ng-container>

            <ng-container
                *ngIf="invitingUser.userRole && invitingUser.userRole !== 'Physician' && invitingUser.userType !== 'doctor'">
                <br />
                <mat-slide-toggle color="primary" [(ngModel)]="invitingUser.canDownloadRecordings">
                    Can download AI audio recordings
                </mat-slide-toggle>
                <br />
            </ng-container>

            <br />

            NOTE: AI features consume tokens.
        </div>


        <p class="hint highlight" *ngIf="invitingUser.userRole === 'Physician'">Adding an additional physician to this
            group
            will increase the subscription amount by ZAR 2000.00 per month</p>

    </div>
    <div mat-dialog-actions class="dialog-actions">
        <button mat-raised-button color="primary" (click)="onInviteSubmit()">{{invitingUser.isEdit? 'Save Changes' :
            'Send Invite'}} </button>
    </div>

</ng-template>


<ng-template #addHospitalDialog>
    <h1 mat-dialog-title>Hospital Details</h1>
    <div mat-dialog-content>
        <div class="p-t-20">
            <div class="field-container">
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Hospital Name</mat-label>
                    <input matInput [(ngModel)]="addingHospital.name">
                </mat-form-field>
            </div>
            <app-ward-settings [(wards)]="addingHospital.wards" [hospitalId]="addingHospital.id"
                (wardDeleted)="trackWardDeletion($event)"></app-ward-settings>
        </div>

    </div>
    <div mat-dialog-actions class="dialog-actions">
        <button mat-raised-button color="primary" (click)="saveHospital()">Save</button>
    </div>

</ng-template>


<ng-template #addMedicationBundleDialog>
    <h1 mat-dialog-title>Bundle Details</h1>
    <div mat-dialog-content>
        <div class="p-t-20">
            <div class="field-container">
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Bundle Name</mat-label>
                    <input matInput [(ngModel)]="addingMedicationBundle.label">
                </mat-form-field>
            </div>
            <div class="toggle-container">
                <mat-slide-toggle [(ngModel)]="addingMedicationBundle.confirmSubstitutions" color="primary">Confirm
                    Substitutions</mat-slide-toggle>
            </div>

            <app-medication-autocomplete [initialData]="addingMedicationBundle.medication" [showActions]="false"
                #medicationList></app-medication-autocomplete>
        </div>

    </div>
    <div mat-dialog-actions class="dialog-actions">
        <button mat-raised-button color="primary" (click)="saveMedicationBundle()">Save</button>
    </div>

</ng-template>


<ng-template #preferredMedicationDialog>
    <h1 mat-dialog-title>Preferred Medication</h1>
    <div mat-dialog-content>
        <div class="p-t-20">
            <app-medication-autocomplete [initialData]="userProfile.preferredMedication" [showActions]="false"
                #preferredMedicationList></app-medication-autocomplete>
        </div>

    </div>
    <div mat-dialog-actions class="dialog-actions">
        <button mat-raised-button color="primary"
            [mat-dialog-close]="preferredMedicationList.getMedicationList()">Save</button>
    </div>

</ng-template>

<ng-template #labTestBundleDialog>
    <h1 mat-dialog-title>{{ editingLabTestBundle.id ? 'Edit' : 'Add' }} Lab Test Bundle</h1>
    <div mat-dialog-content>
        <div class="p-t-20">
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Bundle Name</mat-label>
                <input matInput [(ngModel)]="editingLabTestBundle.label" placeholder="Bundle Name" type="text" required>
            </mat-form-field>

            <mat-form-field appearance="outline" class="full-width m-t-10">
                <mat-label>Lab</mat-label>
                <mat-select [(ngModel)]="editingLabTestBundle.lab">
                    <mat-option value="Lancet">Lancet</mat-option>
                </mat-select>
            </mat-form-field>

            <div class="m-t-20">
                <app-lab-test-selector [mode]="'chips'" [testChips]="editingLabTestBundle.labTests"
                    [showCategoryFilter]="true" [pluralTitle]="'Lab Tests'" [singularTitle]="'Lab Test'"
                    (testsChanged)="onLabTestBundleTestsChanged($event)" #labTestBundleList>
                </app-lab-test-selector>
            </div>
        </div>
    </div>
    <div mat-dialog-actions class="dialog-actions">
        <button mat-button (click)="closeLabTestBundleDialog()">Cancel</button>
        <button mat-raised-button color="primary" (click)="saveLabTestBundle()" [disabled]="isLoading">Save</button>
    </div>
</ng-template>